import React, { ReactNode } from 'react';
import { CategoryHSCodeContext } from './context';
import { useCategoryHSCode } from '../hooks/useCategoryHSCode';
import { Category10DigitEnabled, CategoryHSCodeSelectionProps } from '../types';

export function CategoryHSCodeProvider({
  children,
  onChange,
  value,
  is10DigitCodeEnabled,
}: {
  children: ReactNode;
  onChange?: CategoryHSCodeSelectionProps['onChange'];
  value?: CategoryHSCodeSelectionProps['value'];
} & Category10DigitEnabled) {
  const data = useCategoryHSCode(onChange, value, is10DigitCodeEnabled);
  return <CategoryHSCodeContext.Provider value={data}>{children}</CategoryHSCodeContext.Provider>;
}

export default CategoryHSCodeProvider;
